import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

export const Offerings = () => {
  const hooponopono = {
    title: "Ho'oponopono & EFT Healing",
    startingFrom: "₹999",
    items: [
      { name: "Demo Session", price: "999", oldPrice: null },
      { name: "Monthly Healing Program (16 sessions/month)", price: "9,999", oldPrice: null }
    ]
  };

  const programs = {
    title: "Transformation Programs",
    startingFrom: "₹999",
    items: [
      { name: "7-Day Entry Program (7 Days to Clarity)", price: "999", oldPrice: null },
      { 
        name: "4-Week Shift (1-Month Program)", 
        price: "15,000", 
        oldPrice: null, 
        whatYouGet: "8 one-to-one sessions (2 per week), daily subconscious reprogramming recordings, a weekly action plan with accountability, and healing through EFT, Ho'oponopono and NLP.",
        whatChanges: "Start shifting the beliefs behind your patterns, notice a real change in how you think and respond, and leave with tools you can use yourself."
      },
      { 
        name: "90-Day Flagship Transformation", 
        price: "49,999", 
        oldPrice: null,
        whatYouGet: "Everything in the 4-Week Shift for 12 weeks (24 one-to-one sessions), plus:\n- WhatsApp support between sessions\n- Emergency sessions when you need them\n- A follow-up integration session one month after the program ends",
        whatChanges: "Complete the full Discover → Heal → Transform journey. Shift your identity at its root, practise living from it, and have the support to make the change last."
      }
    ]
  };

  const OfferingCard = ({ offering }) => (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="bg-white p-8 md:p-10 shadow-lg hover:shadow-xl transition-shadow duration-300"
    >
      <h3 className="text-3xl font-bold text-[#333333] mb-2">{offering.title}</h3>
      <p className="text-lg text-[#8B6F47] font-semibold mb-8">
        Starting from {offering.startingFrom}
      </p>

      <div className="space-y-6">
        {offering.items.map((item, index) => (
          <div key={index} className="flex items-start gap-3 pb-6 border-b border-[#e6e5d8] last:border-0">
            <Check className="text-[#8B6F47] flex-shrink-0 mt-1" size={20} />
            <div className="flex-1">
              <p className="text-lg text-[#333333] font-medium mb-2">{item.name}</p>
              <div className="flex items-baseline gap-3 mb-3">
                <span className="text-2xl font-bold text-[#333333]">
                  ₹{item.price}
                </span>
              </div>
              {item.whatYouGet && (
                <div className="mt-3 space-y-2 text-sm text-[#555555]">
                  <p><span className="font-semibold text-[#333333]">What you get:</span> {item.whatYouGet.split('\n').map((line, i) => (
                    <span key={i}>{line}{i < item.whatYouGet.split('\n').length - 1 && <br />}</span>
                  ))}</p>
                  <p><span className="font-semibold text-[#333333]">What changes for you:</span> {item.whatChanges}</p>
                </div>
              )}
              {item.description && !item.whatYouGet && (
                <p className="text-sm text-[#666666] mt-2 italic">{item.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );

  return (
    <section className="py-20 md:py-32 px-6 bg-[#f9f8f3]">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#333333] mb-4">
            Your Path to Transformation
          </h2>
          <p className="text-lg md:text-xl text-[#666666] max-w-3xl mx-auto">
            Whether you're taking your first step or ready for deep, lasting change—there's a path designed for you.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <OfferingCard offering={hooponopono} />
          <OfferingCard offering={programs} />
        </div>
      </div>
    </section>
  );
};
